import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const deleteLevel = (resource, id, { structureId, levelId }) => {
  return axios.delete(
    `/api/${resource}/${id}/setup/level_structures/${structureId}/levels/${levelId}`
  );
};

export const useDeleteLevel = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => deleteLevel(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level successfully deleted', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
